export default {
  title: 'Fund Details',
  selector: {
    allAccounts: 'All accounts',
    wallet: 'Wallet',
    memberWallet: 'Member Wallet',
  },
  fundFlow: {
    self: 'Self',
    external: 'External',
    platform: 'Platform',
    other: 'Others',
  },
  wallet: {
    memberWallet: 'Member Wallet',
  },
  columns: {
    orderNo: 'Order No.',
    operationType: 'Operation Type',
    fundFlow: 'Fund Flow',
    walletId: 'Wallet ID',
    transOutMember: 'From Member',
    transOutAmount: 'Amount Out',
    transOutBeforeAmount: 'Balance Before Out',
    transOutAfterAmount: 'Balance After Out',
    exchangeRate: 'Exchange Rate',
    transInMember: 'Transfer to member',
    transInAmount: 'Amount In',
    transInBeforeBalance: 'Balance Before In',
    transInAfterBalance: 'Balance After In',
    createTime: 'Created Time',
    auditTime: 'Audit Time',
    remark: 'Remark',
    status: 'Status',
  },
  status: {
    refund: 'Refunded',
    finish: 'Approved',
    reject: 'Rejected',
    review: 'Pending',
  },
  operationType: {
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    transferFrom: 'Transfer Out',
    transferTo: 'Transfer In',
    credit: 'Credit',
    commission: 'Commission',
    adjust: 'Adjust',
    rabate: 'Rebate',
  },
}
